import request from '@/utils/request'

// 获取公告信息
export async function getNoticeInfo(params:object = {}) {
  return request('/api/user/notice/info', {
    method: 'GET',
    requestType: 'form',
    data: params
  })

}
